import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import sessionStore from "./modules/session";
import documentStore from "../../../Breeze.FormBuilder.Frontend/store/modules/document";
import documentGroupModule from "../../../Breeze.FormBuilder.Frontend/store/modules/documentGroup";
import appointmentsStore from "./modules/appointments";
import formGroupModule from "../../../Breeze.FormBuilder.Frontend/store/modules/formGroup";
import formBuilder from "../../../Breeze.FormBuilder.Frontend/store/modules/form";
import layoutStore from "./modules/layout";
import episodeOfCareModule from "./modules/episodeOfCare";

export default new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions: {},
  modules: {
    session: sessionStore,
    formBuilder: formBuilder,
    formSubmitter: documentStore,
    formGroup: formGroupModule,
    formGroupSubmitter: documentGroupModule,
    appointments: appointmentsStore,
    layout: layoutStore,
    client: episodeOfCareModule
  }
});
